import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton } from '@/components';
import TextSeatchFilter from '@/components/TextSearchFilter/TextSearchFilter';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import CdpsChart from './CdpsChart';
import IlkCdpsTable from './CdpsTable';
import { useSearchParams } from 'react-router-dom';

export default function SealVaultsPage() {
  const [searchParams] = useSearchParams();
  const what = searchParams.get('what');
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: what === 'borrowers' ? '-debt' : '-ink',
    filtersDebounceTime: 250,
    initialFilters: {
      textSearch: ''
    }
  });

  const [data, error] = useApi({
    url: `/groups/seal/ilks/LSE-MKR-A/`
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={tokensMapping(data.collateral_symbol).address}
                size="5"
              />
            }>
            <Heading size="1">{data.ilk} CDPs</Heading>
          </EntityName>
        }>
        <CdpsChart what={what} />
        <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
          <TextSeatchFilter
            filters={filters}
            placeholder="Search by CDP or URN"
          />
        </Flex>
        <IlkCdpsTable
          pagination={pagination}
          sorting={sorting}
          search={filters.filtersApplied['textSearch']}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
